import script from "./NoticiaView.vue?vue&type=script&setup=true&lang=js"
export * from "./NoticiaView.vue?vue&type=script&setup=true&lang=js"

import "./NoticiaView.vue?vue&type=style&index=0&id=cab060f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cab060f6"]])

export default __exports__